<div class="select-wrapper zn-simple-select">
  <div class="select-input zn-simple-select__trigger">
    <a
      [class.disabled]="disabled"
      [attr.aria-expanded]="dropdownOpen()"
      [attr.aria-disabled]="disabled"
      (click)="toggleDropdown()"
      (keydown)="handleTriggerKeydown($event)"
    >
      <span
        class="placeholder-text"
        [class.selected]="!!selectedOption()"
      >
        {{ toLocalizationKey(displayLabel()) | abpLocalization }}
      </span>
      @if (!(showClearSelection() && hasSelectedValue())) {
        <button
          type="button"
          class="zn-select-action btn btn-tertiary"
          >
          <i [class.bi-chevron-up]="dropdownOpen()" [class.bi-chevron-down]="!dropdownOpen()"></i>
        </button>
      }
    </a>

    @if (showClearSelection() && hasSelectedValue()) {
      <button
        type="button"
        class="zn-select-action btn btn-tertiary zn-simple-select__clear"
        [disabled]="disabled"
        (click)="clearSelection($event)"
      >
        <i class="bi bi-x-lg"></i>
      </button>
    }
  </div>

  @if (dropdownOpen()) {
    <div class="zn-dropdown-menu dropdown-menu show custom-dropdown zn-simple-select__menu" (keydown)="handleMenuKeydown($event)">
      @if (!hasOptions()) {
        <div class="zn-text-disabled zn-simple-select__empty">
          {{ `${localizationResource()}::ZnSelectResultNotFound` | abpLocalization }}
        </div>
      }

      @for (option of normalizedOptions(); track option.key) {
        <button
          type="button"
          class="option-item zn-simple-select__option"
          [class.selected]="isSelected(option.key)"
          [class.active]="$index === activeIndex()"
          (click)="selectOption(option.key)"
        >
          <span>{{ toLocalizationKey(option.value) | abpLocalization }}</span>
        </button>
      }
    </div>
  }
</div>
